import { makeStyles } from '@material-ui/styles';
import { ITheme } from '../../typings/theme';

export default makeStyles((theme: ITheme) => ({
  topLevelContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    boxSizing: 'border-box',
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#FFF',
  },
  inputLabel: {
    fontSize: 12,
    marginTop: 15,
    marginLeft: 3,
  },
  swalDialog: {
    zIndex: 1350,
  },
  selectContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
  },
  containerError: {
    border: 'solid 1px #D41B49',
    borderRadius: 4,
  },
  button: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '4px 0px 0px 4px',
    border: 'none',
    outline: 'none',
    padding: 10,
    backgroundColor: '#FFF',
    color: '#6E6E6E',
    transition: 'background-color 0.4s',
    '&:hover': {
      backgroundColor: '#F6F6F6',
      '& $icon': {
        transform: 'translate(0,-4px)',
      },
    },
  },
  buttonRight: {
    flex: 0.4,
    borderRadius: '0px 4px 4px 0px',
    backgroundColor: '#A4BABB',
    color: '#FFF',
    '&:hover': {
      backgroundColor: '#91AFB0',
    },
  },
  details: {
    fontStyle: 'italic',
    color: '#98A2A5',
    fontSize: 12,
    marginTop: 2,
  },
  icon: {
    color: '#B9CCCD',
    fontSize: '32px',
    transform: 'translate(0,0)',
    transition: 'transform 0.4s',
  },
  iconRight: {
    color: '#FFF',
  },
  imageContainer: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#DEE7EB',
    borderRadius: 4,
  },
  imageContainerWithBase64: {
    marginTop: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  base64Alert: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 3,
    backgroundColor: '#D41B49',
    color: '#FFF',
    width: '100%',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
  },
  image: {
    height: 200,
    maxWidth: '100%',
  },
  closeIcon: {
    position: 'absolute',
    right: 0,
    top: 0,
  },
  uploadButton: {
    padding: '5px 25px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    position: 'absolute',
    backgroundColor: '#B63A59',
    right: 15,
    bottom: 15,
    borderRadius: 4,
    color: '#FFF',
    border: 'none',
    outline: 'none',
    '&:hover': {
      backgroundColor: '#8D2B44',
    },
  },
  blockedContainer: {
    display: 'flex',
    color: '#FFF',
    width: '100%',
    backgroundColor: '#263943',
    marginTop: 8,
    borderRadius: 4,
    padding: 8,
    alignItems: 'center',
  },
  imageName: {
    fontStyle: 'italic',
    fontSize: 12,
  },
  dropzone: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    borderRadius: 4,
    backgroundColor: '#FFF',
    border: 'dashed 1px #000',
  },
  dropzoneContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    marginTop: 10,
    outline: 'none',
  },
  dropzoneImageContainer: {
    height: 200,
  },
  dropzoneSelectContainer: {
    height: 93,
  },
}));
